import { Table, Tbody, Th, Thead, TheadTr } from 'hatch-components';
import React, { useLayoutEffect } from 'react';
import { useConnect } from 'redux-bundler-hook';
import CreateWorkspace from 'root/components/drawers/CreateWorkspace';
import EditWorkspace from 'root/components/drawers/EditWorkspace';
import Card from 'root/components/molecules/Card';
import DefaultTemplate from 'root/components/templates/Default';
import {
  ORGANIZATION_BOARDS,
  ORGANIZATION_TEAM,
} from 'root/stores/fresh/schema';
import { ADD_WORKSPACE, EDIT_WORKSPACE } from 'root/stores/routes/APP_URLS';

import WorkspaceEmptyState from './components/WorkspaceEmptyState';
import WorkspaceRow from './components/WorkspaceRow';
import WorkspaceRowSkeleton from './components/WorkspaceRow/skeleton';
import { StyledButton } from './styles';

const Workspace = () => {
  const {
    doUpdateQuery,
    boardsSortedByArchived,
    queryObject: { drawer },
    workspacePageIsLoading,
    workspacesPageHasErrors,
    numberOfBoards,
    currentOrganizationId,
    doSetFreshOrganizationKey,
  } = useConnect(
    'doUpdateQuery',
    'selectBoardsSortedByArchived',
    'selectQueryObject',
    'selectWorkspacePageIsLoading',
    'selectWorkspacesPageHasErrors',
    'selectNumberOfBoards',
    'selectCurrentOrganizationId',
    'doSetFreshOrganizationKey',
  );

  // using layout effect to prevent flash
  // TODO: replace with sockets and fresh state
  useLayoutEffect(() => {
    // when route loads, reset organization team key to trigger re-fetch
    doSetFreshOrganizationKey({
      fresh: false,
      key: ORGANIZATION_TEAM,
      organizationIDs: [currentOrganizationId],
    });
    // when route loads, reset organization boards key to trigger re-fetch
    doSetFreshOrganizationKey({
      fresh: false,
      key: ORGANIZATION_BOARDS,
      organizationIDs: [currentOrganizationId],
    });
  }, [doSetFreshOrganizationKey, currentOrganizationId]);

  const getHeaderRight = () => (
    <StyledButton
      data-test-id="105f934d-ac36-4ddd-abba-3746ba1d8d4e"
      onClick={() => doUpdateQuery({ drawer: ADD_WORKSPACE })}
      variant="stroke"
    >
      + <span>Add Workspace</span>
    </StyledButton>
  );

  return (
    <DefaultTemplate
      showErrorState={workspacesPageHasErrors}
      title="Workspaces"
    >
      <Card
        headerRight={getHeaderRight}
        title={`Workspaces (${numberOfBoards || 0})`}
      >
        <Table>
          <Thead>
            <TheadTr>
              <Th>Workspace</Th>
              <Th>Department ID</Th>
              <Th>Users Assigned</Th>
              <Th>Created Date</Th>
              <Th />
            </TheadTr>
          </Thead>
          <Tbody>
            {workspacePageIsLoading ? (
              <>
                <WorkspaceRowSkeleton />
                <WorkspaceRowSkeleton />
                <WorkspaceRowSkeleton />
                <WorkspaceRowSkeleton />
                <WorkspaceRowSkeleton />
              </>
            ) : null}
            {!workspacePageIsLoading && boardsSortedByArchived.length ? (
              boardsSortedByArchived.map((board) => {
                return (
                  <WorkspaceRow
                    archived={!board.active}
                    createdAt={board?.settings?.createdAt}
                    departmentId={board?.workspaceGroup?.locationId}
                    id={board.id}
                    mongoId={board.mongoId}
                    key={board.mongoId}
                    name={board.name}
                  />
                );
              })
            ) : (
              <WorkspaceEmptyState
                data-test-id="dce80f04-31cf-426d-af37-116f50486251"
                onClick={() => doUpdateQuery({ drawer: ADD_WORKSPACE })}
              />
            )}
          </Tbody>
        </Table>
      </Card>
      <CreateWorkspace active={drawer === ADD_WORKSPACE} />
      <EditWorkspace active={drawer === EDIT_WORKSPACE} />
    </DefaultTemplate>
  );
};

export default Workspace;
